module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/common/mark_circle-1126dbadace59582bdc48b791a80c44a.svg";